import { Descriptor } from '../../Descriptor'
import { formatOptions } from '../../Format'
import { Options } from '../../Options'
import { chartMarkOptions } from '../ChartMark'

export const chartReferenceLineOptions = {
  ...Options.asRecord(
    Options.createOption({
      key: 'axis',
      inputKind: 'select',
      selectChoices: [
        { value: 'x', label: 'X' },
        { value: 'y', label: 'Y' },
      ],
      label: 'Axis',
      description: 'Axis a nested reference line belongs to.',
      category: 'Data',
    }),
    Options.createOption({
      key: 'value',
      inputKind: 'reference_line_value',
      ofType: Options.scalar<string | number>('StringOrNumber'),
      label: 'Value',
      description: 'Reference-line value on the selected axis.',
      category: 'Data',
    }),
    Options.createOption({
      key: 'showLabel',
      inputKind: 'boolean',
      label: 'Show label',
      description: 'Show a label on a nested reference line.',
      category: 'Data',
    }),
    Descriptor.options.label,
    Options.createNested({
      key: '_referenceLines',
      list: true,
      label: 'Reference lines',
      description: 'Reference-line state available to chart renderers.',
      category: 'Data',
    }),
  ),
  ...chartMarkOptions,
  ...formatOptions,
}

export type ChartReferenceLineItem = Options.TypeOf<
  typeof chartReferenceLineOptions
>
export type ChartReferenceLineOptions = Options.TypeOf<
  typeof chartReferenceLineOptions
>
